export default {
      id: "reefer-active-zone-usage",
      viewBox: "0 0 36 18",
      url: __webpack_public_path__ + "img/icons.svg#reefer-active-zone",
      toString: function () {
        return this.url;
      }
    }